import React from 'react'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, mobileAbout } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage
            src={mobileAbout}
            w="95%"
            alt="One Sushi Japanese Restaurant About"
          />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView row justifyStart alignCenter maxWidth="1400px" m="0 auto">
          <CFImage
            src={about}
            w="100%"
            alt="One Sushi Japanese Restaurant About"
          />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
